import { render } from "./addManagerView.vue?vue&type=template&id=21747bc5&scoped=true&ts=true"
import script from "./addManagerView.vue?vue&type=script&lang=ts"
export * from "./addManagerView.vue?vue&type=script&lang=ts"

import "./addManagerView.vue?vue&type=style&index=0&id=21747bc5&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21747bc5"]])

export default __exports__